// 2026-06-25: Shared shop image registry.
// Maps shop_type enum values to their AI-generated illustration.
// Used by Operations Map, Buildings master, Machine Group master, WO Workbench.
import machineShop from '../../assets/shop-images/shop_machine_shop.png';
import assembly from '../../assets/shop-images/shop_assembly.png';
import deburring from '../../assets/shop-images/shop_deburring.png';
import specialProcess from '../../assets/shop-images/shop_special_process.png';
import inspection from '../../assets/shop-images/shop_inspection.png';
import packing from '../../assets/shop-images/shop_packing.png';
import other from '../../assets/shop-images/shop_other.png';

export const SHOP_IMAGES = {
  MACHINE_SHOP: machineShop,
  ASSEMBLY: assembly,
  DEBURRING: deburring,
  SPECIAL_PROCESS: specialProcess,
  INSPECTION: inspection,
  PACKING: packing,
  OTHER: other,
};

export const SHOP_LABELS = {
  MACHINE_SHOP: 'Machine Shop',
  ASSEMBLY: 'Assembly',
  DEBURRING: 'Deburring',
  SPECIAL_PROCESS: 'Special Process',
  INSPECTION: 'Inspection',
  PACKING: 'Packing',
  OTHER: 'Other',
};

export const SHOP_COLORS = {
  MACHINE_SHOP: '#2563eb',
  ASSEMBLY: '#16a34a',
  DEBURRING: '#f59e0b',
  SPECIAL_PROCESS: '#dc2626',
  INSPECTION: '#9333ea',
  PACKING: '#6b7280',
  OTHER: '#4b5563',
};

export function getShopImage(shopType) {
  return SHOP_IMAGES[shopType] || other;
}

export function getShopLabel(shopType) {
  return SHOP_LABELS[shopType] || 'Other';
}

export function getShopColor(shopType) {
  return SHOP_COLORS[shopType] || SHOP_COLORS.OTHER;
}
